import * as types from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  addedDirector: null
};

const authorsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_DIRECTORS_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta
      };
    case types.ADD_DIRECTOR_RESPONSE:
      return { ...state, addedAuthor: action.payload };
    default:
      return state;
  }
};

export default authorsReducer;
